import React, { Component, lazy, Suspense } from "react";
import { Route, Switch, Redirect } from "react-router";
import { connect } from "react-redux";

import { BigLoader } from "./../components/UI/Loader/Loader";
import HomePage from "./../components/Views/HomePage/HomePage";

import Error404 from "./../components/Views/Pages/Error404/Error404";
import * as action from "./../store/action/index";
import styles from "./App.module.css";

class App extends Component {
  componentDidMount() {
    this.props.autoLogin();
  }
  render() {
    const VerifyEmail = lazy(() =>
      import("./../components/Views/Pages/VerifyEmail/VerifyEmail")
    );
    const VerifyPassword = lazy(() =>
      import(
        "./../components/Forms/CommonForm/ForgetPass/VerifyPass/VerifyPass"
      )
    );
    const ForgetPassword = lazy(() =>
      import("./../components/Forms/CommonForm/ForgetPass/ForgetPass")
    );
    const ResetPassword = lazy(() =>
      import("./../components/Forms/CommonForm/ResetPass/ResetPassword")
    );
    const SupportPage = lazy(() =>
      import("./../components/Views/SupportPage/SupportPage")
    );
    const Signup = lazy(() =>
      import("./../components/Forms/Signup/Faculty/Signup")
    );
    const FacultyView = lazy(() =>
      import("./../components/Views/FacultyView/FacultyView")
    );
    const AdminView = lazy(() =>
      import("./../components/Views/AdminView/AdminView")
    );

    let routes = <BigLoader />;
    if (!this.props.token && !this.props.loading) {
      routes = (
        <>
          <Switch>
            <Route path="/" exact component={HomePage} />
            <Suspense fallback={<BigLoader />}>
              <Switch>
                <Route path="/signup" exact component={Signup} />
                <Route
                  path="/forgetpassword/:role"
                  component={ForgetPassword}
                />
                <Route path="/resetpassword" exact component={ResetPassword} />
                <Route
                  path="/verifyemail/:role/:token"
                  exact
                  component={VerifyEmail}
                />
                <Route
                  path="/verifypassword/:role/:token"
                  exact
                  component={VerifyPassword}
                />
                <Route path="/support" exact component={SupportPage} />
                {this.props.token ? "" : <Redirect to="/" exact />}
              </Switch>
            </Suspense>
          </Switch>
        </>
      );
    }
    if (this.props.token && this.props.role === "faculty") {
      routes = (
        <>
          <Switch>
            <Redirect from="/" to="/faculty" exact />
            <Suspense fallback={<BigLoader />}>
              <Switch>
                <Route path="/faculty" component={FacultyView} />
                <Route path="/support" exact component={SupportPage} />
                <Route exact component={Error404} />
              </Switch>
            </Suspense>
            <Route exact component={Error404} />
          </Switch>
        </>
      );
    }
    if (this.props.token && this.props.role === "admin") {
      routes = (
        <>
          <Switch>
            <Redirect from="/" to="/admin" exact />
            <Suspense fallback={<BigLoader />}>
              <Switch>
                <Route path="/admin" component={AdminView} />
                <Route path="/support" exact component={SupportPage} />
                <Route exact component={Error404} />
              </Switch>
            </Suspense>
            <Route exact component={Error404} />
          </Switch>
        </>
      );
    }
    return <div className={styles.App}>{routes}</div>;
  }
}
const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    loading: state.auth.loading,
    role: state.auth.role,
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    autoLogin: () => {
      dispatch(action.checkAutoLogin());
    },
  };
};

export default connect(mapStateToProps, mapsDispatchToProps)(App);
